export enum BillStatementStatuses {
    None = 0,
    Open = 1,
    FinanceRelease= 2,
    Issued = 3,
    Canceled = 4,
    Halted = 5
}
